export default __webpack_public_path__ + "static/auto-07de204809a3b307345f104c6e645458.png";